/**
 * The fan drawing family — the ids `FanAnimation.vue` draws.
 *
 * The hub declares `settings.fan_style` on its `fan` class. It is `fan_style` and
 * not `fan_type` because that key is already the behavioural choice (on/off,
 * stepped or continuous speed), which decides the values the class publishes.
 */
import { fanKindOf } from '../../devices/deviceWidgetTypes';
import { variantFromSetting, variantValues, type VariantFamily } from './types';

export const FAN_VARIANTS: VariantFamily = {
  drawing: 'fan',
  settingKey: 'fan_style',
  title: ['Fan style', 'Vrsta ventilatorja'],
  description: [
    'The kind of fan this is. The tile draws it; the controls stay.',
    'Vrsta tega ventilatorja. Ploščica jo nariše; upravljanje ostane.',
  ],
  options: [
    { value: 'auto', icon: 'settings_suggest', label: ['Automatic', 'Samodejno'] },
    { value: 'ceiling', icon: 'ceiling_fan', label: ['Ceiling fan', 'Stropni ventilator'] },
    { value: 'pedestal', icon: 'mode_fan', label: ['Pedestal / stand fan', 'Stoječi ventilator'] },
    { value: 'table', icon: 'table_restaurant', label: ['Table fan', 'Namizni ventilator'] },
    { value: 'wall', icon: 'wall_art', label: ['Wall fan', 'Stenski ventilator'] },
    { value: 'tower', icon: 'height', label: ['Tower fan', 'Stolpni ventilator'] },
    { value: 'extractor', icon: 'air', label: ['Extractor fan', 'Kopalniški ventilator'] },
    { value: 'duct', icon: 'swap_horiz', label: ['Inline duct fan', 'Kanalski ventilator'] },
    { value: 'erv', icon: 'sync_alt', label: ['Heat-recovery unit', 'Prezračevalna naprava'] },
  ],
  defaultValue: 'auto',
  resolve: (device) =>
    variantFromSetting(device.settings, 'fan_style', variantValues(FAN_VARIANTS)) ?? fanKindOf(device),
};
